'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002483 from "./presto.-Two-Factor-Auth-View$$anon$83.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002485 from "./presto.-Two-Factor-Auth-View$$anon$85.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002487 from "./presto.-Two-Factor-Auth-View$$anon$87.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002489 from "./presto.-Two-Factor-Auth-View$$anon$89.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024 from "./presto.types$-Two-Factor-Auth-Usage$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$82() {
  this.bHX = null;
  this.bHP = null;
  this.bHQ = false;
  this.bHY = null;
  this.bHZ = false;
  this.bI2 = null;
  this.bHV = null;
  this.bHW = false;
  this.bHR = null;
  this.bHS = false;
  this.bHT = null;
  this.bHU = false;
  this.bI0 = false;
  this.bI1 = false;
  this.bHX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bI2 = "TwoFactorAuthUsage";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$82 as $c_Lpresto_TwoFactorAuthView$$anon$82 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$82.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$82;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$82() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$82 as $h_Lpresto_TwoFactorAuthView$$anon$82 };
$h_Lpresto_TwoFactorAuthView$$anon$82.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bHX;
});
$p.L = (function() {
  if ((!this.bHQ)) {
    this.bHP = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bHQ = true;
  }
  return this.bHP;
});
$p.O = (function() {
  if ((!this.bHZ)) {
    this.bHY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bHZ = true;
  }
  return this.bHY;
});
$p.E = (function() {
  return this.bI2;
});
$p.t = (function() {
  if ((!this.bHW)) {
    this.bHV = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("tfa", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("sites", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("credentials", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bHW = true;
  }
  return this.bHV;
});
$p.M = (function() {
  if ((!this.bHS)) {
    this.bHR = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002483.$c_Lpresto_TwoFactorAuthView$$anon$83(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002485.$c_Lpresto_TwoFactorAuthView$$anon$85())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002487.$c_Lpresto_TwoFactorAuthView$$anon$87())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bHS = true;
  }
  return this.bHR;
});
$p.Q = (function() {
  if ((!this.bHU)) {
    this.bHT = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002489.$c_Lpresto_TwoFactorAuthView$$anon$89();
    this.bHU = true;
  }
  return this.bHT;
});
$p.w = (function() {
  if ((!this.bI1)) {
    this.bI0 = false;
    this.bI1 = true;
  }
  return this.bI0;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee983) => ((p) => \u03b4scrutinee983.z3(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024.$m_Lpresto_types$TwoFactorAuthUsage$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$82 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$82, "presto.TwoFactorAuthView$$anon$82", ({
  Tm: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$82 as $d_Lpresto_TwoFactorAuthView$$anon$82 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$82.js.map
